import styled from "styled-components";
import DesignConstants from "../../../../../../constants/DesignConstants";
import PhaseSixIcon from "../../../../../../basic/phaseSixIcon/PhaseSixIcon";

export const ConnectOuterWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${DesignConstants.SPACES.M};

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        flex-wrap: nowrap;
        gap: ${DesignConstants.SPACES.XS};
    }
`;

export const WordsColumn = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    min-width: 0;
    gap: ${DesignConstants.SPACES.S};

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        gap: ${DesignConstants.SPACES.XS};
    }
`;

export const ConnectWrapper = styled.div<{ rightColumn?: boolean; color?: string }>`
    display: flex;
    flex-direction: ${(props) => (props.rightColumn ? "row-reverse" : "row")};
    align-items: center;
    background-color: ${DesignConstants.COLORS.WHITE};
    border-top: ${DesignConstants.BORDERS.MEDIUM} ${DesignConstants.COLORS.LIGHT_GREY};
    border-bottom: ${DesignConstants.BORDERS.MEDIUM} ${DesignConstants.COLORS.LIGHT_GREY};
    ${(props) =>
        props.rightColumn
            ? `border-right: ${DesignConstants.BORDERS.MEDIUM} ${DesignConstants.COLORS.LIGHT_GREY};`
            : `border-left: ${DesignConstants.BORDERS.MEDIUM} ${DesignConstants.COLORS.LIGHT_GREY};`}
    ${(props) =>
        props.rightColumn
            ? `border-left: ${DesignConstants.SPACES.XS} solid ${props.color ?? DesignConstants.COLORS.DARK_GREY};`
            : `border-right: ${DesignConstants.SPACES.XS} solid ${props.color ?? DesignConstants.COLORS.DARK_GREY};`}
    border-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
    padding: ${DesignConstants.SPACES.S};
    gap: ${DesignConstants.SPACES.S};
    min-width: 0;

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        padding: ${DesignConstants.SPACES.XS};
        gap: ${DesignConstants.SPACES.XS};
    }
`;

export const ConnectWord = styled.div`
    display: block;
    flex: 1;
    min-width: 0;
    text-align: center;
    font-size: ${DesignConstants.FONT_SIZES.M};
    font-weight: ${DesignConstants.FONT_WEIGHTS.SEMI_BOLD};
    color: ${DesignConstants.COLORS.DARK_GREY};
    overflow-wrap: anywhere;
`;

export const Balancer = styled.div`
    flex-shrink: 0;
    width: ${DesignConstants.FONT_SIZES.XL};
    height: ${DesignConstants.FONT_SIZES.XL};

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        display: none;
    }
`;

export const RemoveIcon = styled(PhaseSixIcon)`
    display: flex;
    flex-shrink: 0;
    font-size: ${DesignConstants.FONT_SIZES.XL};
    cursor: pointer;
`;

export const RemoveIconWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${DesignConstants.SPACES.S};
    padding: ${DesignConstants.SPACES.S} ${DesignConstants.SPACES.M};
`;
